import { LegalLayout, Section } from "@/components/LegalLayout";
import { usePageMeta } from "@/utils/pageMeta";

const Privacy = () => {
  usePageMeta("Politique de confidentialité — ActiPilote", "Politique de confidentialité du site actipilote.com : données collectées, finalités, durées de conservation et droits des utilisateurs.");

  return (
    <LegalLayout eyebrow="Légal" title="Politique de confidentialité" updated="septembre 2026" testid="privacy-page">
      <Section title="1. Responsable du traitement">
        <p>Le responsable du traitement des données collectées sur le site actipilote.com est :</p>
        <p><span className="font-semibold text-navy">FULL AGENCY</span> — EURL au capital social de 1 000,00 €<br />
        Siège social : 68 rue de la Croix de l'Orme, 78630 Morainvilliers, France<br />
        SIRET : 978 641 348 00047</p>
        <p>Pour toute question relative à vos données personnelles : <a href="mailto:contact@actipilote.com" className="font-semibold text-brand hover:underline">contact@actipilote.com</a>.</p>
      </Section>
      <Section title="2. Données collectées">
        <p>Via le formulaire de contact du site actipilote.com, nous collectons les informations que vous nous transmettez : nom, adresse e-mail, société, type d'activité et contenu de votre message.</p>
        <p>Ces données servent exclusivement à traiter votre demande de contact ou de démonstration.</p>
      </Section>
      <Section title="3. Finalités et base légale">
        <p>Les données collectées via ce site sont utilisées pour : répondre à vos demandes, organiser des démonstrations de la plateforme et assurer le suivi commercial de votre demande. La base légale est votre consentement et les mesures précontractuelles prises à votre demande.</p>
      </Section>
      <Section title="4. Destinataires et sous-traitants">
        <p>Vos données ne sont ni vendues ni partagées avec des tiers à des fins commerciales. Elles sont traitées par l'équipe ActiPilote et, pour l'envoi des e-mails, par notre prestataire technique d'acheminement des messages.</p>
      </Section>
      <Section title="5. Durée de conservation">
        <p>Les données transmises via le formulaire de contact (demandes de démonstration et de contact commercial) sont conservées 12 mois à compter de votre demande, puis supprimées ou anonymisées.</p>
      </Section>
      <Section title="6. Vos droits">
        <p>Conformément à la réglementation applicable en matière de protection des données, vous disposez de droits d'accès, de rectification, d'effacement, de limitation et d'opposition concernant vos données. Pour les exercer : <a href="mailto:contact@actipilote.com" className="font-semibold text-brand hover:underline">contact@actipilote.com</a>.</p>
      </Section>
      <Section title="7. Cookies">
        <p>Le site utilise uniquement des cookies et technologies techniques nécessaires à son fonctionnement, ainsi qu'un outil de mesure d'audience aux données anonymisées. Aucun cookie publicitaire n'est déposé.</p>
        <p>Vous pouvez à tout moment configurer votre navigateur pour refuser les cookies ; la navigation sur le site restera possible.</p>
      </Section>
    </LegalLayout>
  );
};

export default Privacy;
